export default "__VITE_ASSET__c5f3edfa__"